import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { api } from '../../lib/api/endpoints'
import { useAuth } from './AuthProvider'

export function ProtectedRoute() {
  const { authenticated, restored } = useAuth()
  const location = useLocation()
  const verification = useQuery({ queryKey: ['session-verification'], queryFn: ({ signal }) => api.dashboard(signal), enabled: authenticated && restored, staleTime: 5 * 60_000, retry: false })
  if (!restored) return <div className="session-loader"><div className="spinner" /><span>Đang khôi phục phiên…</span></div>
  if (!authenticated) return <Navigate to="/login" replace state={{ from: location.pathname }} />
  if (verification.isPending) return <div className="session-loader"><div className="brand-mark">N</div><div className="spinner" /><span>Đang xác minh phiên quản trị…</span></div>
  if (verification.isError) return <Navigate to="/login" replace />
  return <Outlet />
}
